export const selectShowTranslated = (state) => state.ui.messages.showTranslated;
